'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React from 'react';
import {LoadMoreComponent} from '../../../core-components/loading-icon/components/LoadMoreComponent';
import {ViewMode} from '../../../core-utilities/enums/ViewMode';
import {MeasuredChatView} from '../../lists/MeasuredChatView';
import {NavigationBreadcrumb} from '../NavigationBreadcrumb';
import {ViewHeader} from '../ViewHeader';


// TODO: this is an initial draft of the layout for the MTR views.
// TODO: improve upon to handle as much of the standard layout as practical.
export function ProjectLayoutView(props) {
  const scrollAreaClassNames = !props.useDnD
    ? "ProjectLayout__scrollArea"
    : classNames("ProjectLayout__scrollArea", props.dropPanelClassName, {
      [props.isDraggingPanelClassName]: props.isDragging,
    });

  return (
    <div className={classNames("ProjectLayout", props.className)}>
      <ViewHeader
        showBackButton={props.showBackButton}
        onGoBack={props.onGoBack}
      >
        <div className="ProjectLayout__header">
          <div className="ProjectLayout__headerLeft">
            <NavigationBreadcrumb
              className="ProjectLayout__breadcrumb"
              path={props.breadcrumbPath}
            />
            <div className="ProjectLayout__title">
              {props.title}
            </div>
          </div>

          {props.filterComponent ? (
            <div className="ProjectLayout__desktopFilter">
              {props.filterComponent}
            </div>
          ) : null}

          <div className="ProjectLayout__headerRight">
            {props.headerRightContent ? props.headerRightContent : null}
          </div>
        </div>
      </ViewHeader>

      <div className="ProjectLayout__navBar">
        {props.navBarContent}
      </div>

      {props.filterComponent ? (
        <div className="ProjectLayout__mobileFilter">
          {props.filterComponent}
        </div>
      ) : null}

      {props.useScroll ? (
        <div
          className={scrollAreaClassNames}
          onDragEnter={props.onDragEnter}
          onDragLeave={props.onDragLeave}
          onDragOver={props.onDragOver}
          onDrop={props.onDrop}
        >
          <MeasuredChatView
            className="ProjectLayout__scroll"
            flipped={false}
            autoScroll={false}
            scrollLoadThreshold={50}
            onInfiniteLoad={props.onLoadMore}
            usePropLoading={true}
            loadingSpinnerDelegate={<LoadMoreComponent mode={props.mode} />}
            isInfiniteLoading={props.mode === ViewMode.LOADING_MORE}
          >
            <div className="ProjectLayout__content">
              {props.bannerContent ? (
                <div className="ProjectLayout__banner">
                  {props.bannerContent}
                </div>
              ) : null}

              {props.children}
            </div>
          </MeasuredChatView>
        </div>
      ) : props.children}
    </div>
  );
}

ProjectLayoutView.propTypes = {
  className: T.string,
  useScroll: T.bool,
  isDragging: T.bool,
  dropPanelClassName: T.string,
  isDraggingPanelClassName: T.string,

  breadcrumbPath: T.array,
  title: T.node,
  filterComponent: T.node,
  headerRightContent: T.node,
  navBarContent: T.node.isRequired,
  bannerContent: T.node,

  useDnD: T.bool,
  onDragEnter: T.func,
  onDragLeave: T.func,
  onDragOver: T.func,
  onDrop: T.func,
};

ProjectLayoutView.defaultProps = {
  useScroll: true,
  useDnD: false,
};



// WEBPACK FOOTER //
// ./src/js/components/views/ProjectLayout/ProjectLayoutView.js